import { makeStyles } from '@material-ui/core';
import { getProgramColorByType } from '../../../../helpers/travel/travelCalcHelpers';

const useStyles = makeStyles((theme) => ({
  tabsContainer: {
    marginBottom: '1rem',
  },
  sectionTitle: {
    marginTop: '1rem',
    marginBottom: '1rem',
    fontSize: 20,
    [theme.breakpoints.down('lg')]: {
      fontSize: 16,
    },
  },
  buttonGroup: {
    background: theme.palette.white.efesBackgroundLight,
    borderRadius: 6,
    display: 'flex',
    '& > button': {
      flex: 1,
    },
    padding: 3,
  },
  programButton: {
    borderRadius: '6px !important',
    boxShadow: 'none',
    transition: 'none',
    margin: '.2rem',
    fontSize: '1.5rem',
    height: '3rem',
    color: theme.palette.black.main,
  },
  divider: {
    height: 7,
    borderRadius: 3,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  programDetails: {
    padding: '0 1rem',
    backgroundColor: theme.palette.white.efesBackgroundLight,
    [theme.breakpoints.down(767)]: {
      padding: '1rem',
    },
  },
  contractRiskAmountWrapper: {
    paddingRight: ({ isDeviceMdSize }) => (!isDeviceMdSize ? '2rem' : 0),
  },
  icon: {
    marginRight: '.5rem',
  },
  label: {
    opacity: 1,
    color: theme.palette.black.main,
    fontSize: 14,
    paddingLeft: 5,
  },
  warning: {
    paddingTop: 2,
  },
  borderGrid: {
    position: 'relative',
    '&::before': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      borderTop: '1px solid #ccc',
      boxSizing: 'border-box',
    },
  },
  priceSection: {
    color: theme.palette.white.main,
    fontSize: '1.75rem',
    fontWeight: 'bold',
    height: 76,
    backgroundColor: ({ selectedPlan }) => getProgramColorByType(selectedPlan),
    [theme.breakpoints.up('md')]: {
      borderRadius: '0px 0px 20px 20px',
      width: 247,
    },
    [theme.breakpoints.down('md')]: {
      height: '4.8rem',
    },
  },
  plansDescription: {
    marginTop: '0.5rem',
  },
  textWrapper: {
    padding: 0,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
  },
  text: {
    lineHeight: '1.4rem',
    fontWeight: 'normal',
    width: '100%',
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 12,
    },
  },
  amountWrapper: {
    margin: '0.5rem 0',
    textAlign: 'center',
    fontSize: 28,
    display: 'flex',
    justifyContent: 'center',
    height: '1.75rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
  infoGrid: {
    marginBottom: 8,
  },
}));

export default useStyles;
